/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  none,
  optimisticLockingOf,
  RestSettings,
  identity,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { OfficeRoleDto } from './office-role.dto';
import { OfficeRoleMapper } from './office-role.mapper';

@Injectable()
export class OfficeRoleRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  create(role: OfficeRoleDto): Observable<OfficeRoleDto> {
    return this.httpPost(`${this.bp}/office-roles`, role, optimisticLockingOf(OfficeRoleMapper));
  }

  update(role: OfficeRoleDto): Observable<OfficeRoleDto> {
    return this.httpPut(`${this.bp}/office-roles/${role.id}`, role, optimisticLockingOf(OfficeRoleMapper));
  }

  get(id: ID): Observable<OfficeRoleDto> {
    return this.httpGet(`${this.bp}/office-roles/${id}`, optimisticLockingOf(OfficeRoleMapper));
  }

  findAll(showDeleted?: boolean): Observable<OfficeRoleDto[]> {
    let url = `${this.bp}/office-roles`;
    if (showDeleted) {
      url += '?showDeleted=true';
    } else {
      url += '?showDeleted=false';
    }
    return this.httpGet(url, arrayOf(OfficeRoleMapper));
  }

  getOfficeRoles(): Observable<OfficeRoleDto[]> {
    return this.httpGet(`${this.bp}/office-roles/list`, arrayOf(OfficeRoleMapper));
  }

  checkUsage(role: OfficeRoleDto): Observable<{ used: boolean }> {
    return this.httpGet(`${this.bp}/office-roles/check-usage/${role.id}`, identity());
  }

  delete(id: ID): Observable<any> {
    return this.httpPut(`${this.bp}/office-roles/${id}/delete`, {}, none());
  }

  undelete(id: ID): Observable<any> {
    return this.httpPut(`${this.bp}/office-roles/${id}/undelete`, {}, none());
  }
}
